"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _ListContext = _interopRequireDefault(require("./_ListContext"));
var _ListboxItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ListboxItem.css") : void 0);
var _excluded = ["children", "className", "disabled", "divider", "isActive", "isSelected", "itemContentProps", "itemSelectorProps", "itemSelectorIconProps", "itemWrapperProps", "onClick", "selectorPosition", "topAlign"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CSS_BLOCK = 'sapcnqr-listbox-item';
var ListboxItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    divider = props.divider,
    isActive = props.isActive,
    isSelected = props.isSelected,
    itemContentProps = props.itemContentProps,
    itemSelectorProps = props.itemSelectorProps,
    itemSelectorIconProps = props.itemSelectorIconProps,
    itemWrapperProps = props.itemWrapperProps,
    onClick = props.onClick,
    selectorPosition = props.selectorPosition,
    topAlign = props.topAlign,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_ListboxItem.default);
  var listContextValue = (0, _react.useContext)(_ListContext.default);
  var _ref = listContextValue || {},
    bordered = _ref.bordered,
    selectionType = _ref.selectionType,
    size = _ref.size,
    gridItemClassName = _ref.gridItemClassName,
    gridItemSelectorClassName = _ref.gridItemSelectorClassName,
    selectedGridItemClassName = _ref.selectedGridItemClassName,
    activeGridItemClassName = _ref.activeGridItemClassName,
    disabledGridItemClassName = _ref.disabledGridItemClassName,
    gridItemWrapperClassName = _ref.gridItemWrapperClassName,
    orientation = _ref.orientation,
    contextDisabled = _ref.disabled;
  var isDisabled = disabled || contextDisabled;
  var liRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([ref, liRef]);
  var classes = classnames(CSS_BLOCK, className, gridItemClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--active"), isActive), activeGridItemClassName, isActive && activeGridItemClassName), "".concat(CSS_BLOCK, "--bordered"), bordered), "".concat(CSS_BLOCK, "--selected"), isSelected), selectedGridItemClassName, isSelected && selectedGridItemClassName), "".concat(CSS_BLOCK, "--disabled"), disabled && !contextDisabled), "".concat(CSS_BLOCK, "--all-disabled"), contextDisabled), disabledGridItemClassName, isDisabled && disabledGridItemClassName), "".concat(CSS_BLOCK, "--horizontal"), orientation === 'horizontal'));
  if (divider) {
    var _context;
    return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, otherProps, {
      className: classnames(className, CSS_BLOCK, "".concat(CSS_BLOCK, "__divider"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__divider--")).call(_context, orientation), orientation !== 'vertical')),
      ref: ref,
      role: "separator",
      "aria-hidden": true
    }));
  }
  var handleClick = function handleClick(event) {
    if (typeof onClick === 'function' && !isDisabled) {
      onClick(event, liRef === null || liRef === void 0 ? void 0 : liRef.current, isSelected);
    }
  };
  var renderChildren = function renderChildren() {
    var _context2, _context3;
    var wrapperClasses = classnames("".concat(CSS_BLOCK, "__wrapper"), itemWrapperProps === null || itemWrapperProps === void 0 ? void 0 : itemWrapperProps.className, gridItemWrapperClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "__wrapper--")).call(_context2, size), size !== 'lg'), (0, _concat.default)(_context3 = "".concat(CSS_BLOCK, "__wrapper--")).call(_context3, selectorPosition), (selectorPosition === null || selectorPosition === void 0 ? void 0 : (0, _trim.default)(selectorPosition).call(selectorPosition)) && selectionType !== 'singleSelectMaster'));
    var selectorClasses = classnames("".concat(CSS_BLOCK, "__selector"), itemSelectorProps === null || itemSelectorProps === void 0 ? void 0 : itemSelectorProps.className, gridItemSelectorClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__selector--topalign"), topAlign));
    var contentClasses = classnames("".concat(CSS_BLOCK, "__content"), itemContentProps === null || itemContentProps === void 0 ? void 0 : itemContentProps.className);
    var iconName = '';
    if (selectionType === 'singleSelectLeft') {
      iconName = isSelected ? 'radiogroup-selected' : 'radiogroup';
    } else if (selectionType === 'multiSelect') {
      iconName = isSelected ? 'checkbox-selected' : 'checkbox';
    }
    if (selectionType === 'singleSelectMaster') {
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, itemWrapperProps, {
        className: wrapperClasses
      }), children);
    }
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, itemWrapperProps, {
      className: wrapperClasses
    }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, itemSelectorProps, {
      className: selectorClasses
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, itemSelectorIconProps, {
      ariaHidden: true,
      iconName: iconName
    }))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, itemContentProps, {
      className: contentClasses
    }), children));
  };
  var ariaSelected = isSelected ? 'true' : 'false';
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react.default.createElement("li", (0, _extends2.default)({}, otherProps, {
      "aria-selected": ariaSelected,
      "aria-disabled": isDisabled,
      className: classes,
      ref: mergedRef,
      role: "option",
      onClick: handleClick
    }), renderChildren())
  );
});
ListboxItem.displayName = 'Listbox.Item';
ListboxItem.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  divider: _propTypes.default.bool,
  isActive: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  itemContentProps: _propTypes.default.object,
  itemSelectorProps: _propTypes.default.object,
  itemSelectorIconProps: _propTypes.default.object,
  itemWrapperProps: _propTypes.default.object,
  selectorPosition: _propTypes.default.string,
  topAlign: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
var _default = exports.default = ListboxItem;